import { defineWidgets } from "../utils/defineWidgets";

export const widgetsFootball = defineWidgets({
  "ld-football-leagues": () => import("./leagues/leagues.tsx"),
  "ld-football-competition-calendar-results": () => import("./competition-calendar-results/competitionCalendarResults.tsx"),
  "ld-football-competition-ranking": () => import("./competition-ranking/competitionRanking.tsx"),
  "ld-football-team-calendar-results": () => import("./team-calendar-results/teamCalendarResults.tsx"),
  "ld-football-match-reports": () => import("./match-reports/matchReports.tsx"),
  "ld-football-match-reports-details": () => import("./match-reports-details/matchReportsDetails.tsx"),
  "ld-football-team-ranking": () => import("./team-ranking/teamRanking.tsx"),
  "ld-football-competition-top-scorers": () => import("./competition-top-scorers/competitionTopScorers.tsx"),
  "ld-football-scorers-ranking-player-page": () => import("./scorers-ranking-player-page/scorersRankingPlayerPage.tsx"),
  "ld-football-competition-predicted-lineups": () => import("./competition-predicted-lineups/competitionPredictedLineups.tsx"),
  "ld-football-match-predicted-lineups": () => import("./match-predicted-lineups/matchPredictedLineups.tsx"),
  "ld-football-team-players": () => import("./team-players/teamPlayers.tsx"),
  "ld-football-competition-board": () => import("./competition-board/competitionBoard.tsx"),
  "ld-football-last-and-next-match": () => import("./team-last-next-match/teamLastNextMatch.tsx"),
});

export const widgetsLmp = defineWidgets({});

export const widgetsDataCards = defineWidgets({});

export const widgetsLiveScore = defineWidgets({});

export const widgetsMap = {
  ...widgetsFootball,
  ...widgetsLmp,
  ...widgetsDataCards,
  ...widgetsLiveScore,
};
